import { ThisReceiver } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { LocalStorageService } from 'angular-web-storage';
import { Observable, Subject } from 'rxjs';
import { ModalContractDocumentComponent } from 'src/app/components/dialogs/modal-contract-document/modal-contract-document.component';
import { LoadingService } from 'src/app/components/loading/loading-service.service';
import { Files } from 'src/app/models/file-model';
import { proposal } from 'src/app/models/proposal-model';
import { userData } from 'src/app/models/user-model';
import { AlertBarService } from '../alert-bar/alert-bar.service';
import { ApiService } from '../api/api.service';
import { SessionService } from '../session/session.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ContractsService {
  completeLoadContracts: Subject<[]> = new Subject();
  completeLoadContracts$: Observable<[]> =
    this.completeLoadContracts.asObservable();
  completeLoadContract: Subject<[]> = new Subject();
  completeLoadContract$: Observable<[]> =
    this.completeLoadContract.asObservable();

  userData: userData;
  token: any;
  list: any;
  pdf: any;
  hasContracts = false;
  hasEmpty = false;
  hasLoad = false;
  canCode = true;
  count: any;
  proposal: any = [];
  hash: any;
  pendent: any;
  andamento: any;
  getID: any;
  contractsPDF!: Array<[]>;
  documentsPendents: any = [];
  redirect: any = [];
  activeProposal: any = [];
  pendentPayCheck = false;
  payCheckInfo: Files | any;
  pendentIndentity = false;
  pendentIndentityVerse = false;
  IdentityInfo: any;
  IdentityInfoVerse: any;
  pendentExtract = false;
  pendentInstallmentHistory = false;
  extractInfo: any;
  residencyDeclared = false;
  acceptedContract = false;
  userBankInfo: any = [];
  debitUrl: any;
  steps: any = [];
  afterDebit!: boolean;
  hasDetails = false;
  proposalID!: string;
  qrCodeLink!: string;
  linkContratoSafari: any;
  lastContractLoaded: string | null = null;

  constructor(
    private session: SessionService,
    private api: ApiService,
    public loader: LoadingService,
    public dialog: MatDialog,
    public toast: AlertBarService,
    private route: Router,
    private storage: LocalStorageService,
    private sanitizer: DomSanitizer,
    private location: Location
  ) {
    this.userData = this.session.getUserData();
    this.token = this.session.getToken();

    // if(!this.hasContracts){
    //   this.load(false)
    // }

    this.getProposta();

    if (this.storage.get('residencyDeclared')) {
      this.residencyDeclared = true;
    }

    if (this.storage.get('acceptedContract')) {
      this.acceptedContract = true;
    }

    if (this.storage.get('afterDebit')) {
      this.afterDebit = true;
    }
  }

  getProposta(storage = true, cb: (list: Array<any>) => void = () => { }) {
    if (storage) {
      this.list = this.storage.get('proposta');
    } else {
      this.api
        .query(
          'proposta',
          {
            requisicao: { CPF: this.userData.CPF, Token: this.token },
          },
          'post'
        )
        ?.subscribe((data: any) => {
          if (data.PropostasPendentesDocumento.length > 0) {
            this.list = data.PropostasPendentesDocumento;
            this.storage.set('proposta', data?.PropostasPendentesDocumento);
            // console.log({ list: this.list });
            this.load(false);
            if (typeof cb === 'function') cb(this.list);
          } else {
            this.list = [];
          }
        });
    }
  }

  setContract(ID: any) {
    this.proposal = ID;
    this.storage.set('activeProposalID', ID);
  }

  async initializeByQRCode(hash: any) {
    if (hash[0]) {
      this.storage.set('Token', hash[0]);
    } else {
      this.storage.remove('Token');
    }

    // Armazena o cpf temporariamente
    this.storage.set('cpfByHash', hash[2]);

    this.api
      .query(
        'proposta',
        { requisicao: { CPF: hash[2], Token: hash[0] } },
        'post'
      )
      ?.subscribe((data: any) => {
        data.PropostasPendentesDocumento.map((proposal: proposal) => {
          if (proposal.CodigoProposta == hash[1]) {
            this.getHash(proposal);
            this.activeProposal = {
              propostaKey: proposal.Key,
              hash: this.hash,
              proposalCode: proposal.CodigoProposta,
              financialCode: proposal.CodigoFinanceira,
            };
            this.storage.set('activeProposalID', proposal.CodigoProposta);
            this.loader.stopLoading();
          }
        });
      });
  }

  load(refresh: boolean, noMesage = false) {
    //this.list = [];
    if (refresh) {
      this.hasContracts = false;
    }

    if ((!this.hasContracts || this.canCode) && this.userData) {
      if (this.canCode == true) {
        this.loader.startLoading();
        //this.api.query('proposta', {requisicao: {CPF: this.userData.CPF, Token: this.token}}, 'post')?.subscribe((data: any) => {
        // console.log(this.list);
        if (this.list?.length > 0) {
          //this.list = data.PropostasPendentesDocumento
          this.list.map(async (proposal: proposal) => {
            // console.log({ proposal });
            if (proposal.CodigoSituacao == 2) {
              this.getProposalDetails(this.list, proposal.CodigoProposta);
            }
          });
          this.completeLoadContracts.next(this.list);
          this.hasContracts = true;

          //if (this.hasLoad && noMesage) {
          //  this.toast.openAlert('Contratos atualizados!', 'success');
          //}
          this.hasLoad = true;
        } else {
          this.hasEmpty = true;
          this.loader.stopLoading();
        }

        this.canCode = false;
        let timeleft = 61;
        const downloadTimer = setInterval(() => {
          if (timeleft <= 1) {
            this.canCode = true;
            clearInterval(downloadTimer);
          }
          const count = 0 - timeleft;
          timeleft -= 1;
          this.count = timeleft;
        }, 1000);

        this.list.map((x: any) => {
          if (x.CodigoSituacao == 3) {
            this.verifyPendencies();
          } else {
            this.loader.stopLoading();
          }
        });

        // }, (e:any) => {
        //   this.loader.stopLoading()
        //   this.toast.openAlert('Algo deu errado. Tente novamente em alguns instantes', 'error')
        // })
      }
    }
  }

  getProposalDetails(proposals: any, proposal: string) {
    proposals.map((p: any) => {
      if (p.CodigoProposta == proposal) {
        this.proposal = p;
        this.storage.set('activeProposal', p);
        // console.log(this.proposal);
      }
    });
  }

  getProposalDetailsById(proposalId: string) {
    this.list.map((p: any) => {
      if (p.CodigoProposta == proposalId) {
        // console.log(p);
        this.storage.set('activeProposal', p);
        return p;
      }
    });
  }

  getPDFIframe(proposalID: string, callback: (base64: string) => void): void {
    this.loader.startLoading('Seu contrato está quase pronto!<br> Por favor, Aguarde');

    this.list.map((proposal: proposal) => {
      if (proposal.CodigoProposta == proposalID) {
        this.api
          .query(
            'proposta/documento/pdf',
            { requisicao: { token: this.token, Key: proposal.Key } },
            'post'
          )
          ?.subscribe(
            (pdf: any) => {
              if (pdf.Conteudo === null) {
                this.toast.openAlert(
                  'Houve um erro ao abrir o contrato tente novamente em alguns minutos!',
                  'error'
                );
                this.location.back();
              }
              else
              {
              this.pdf = pdf.Conteudo;
              this.lastContractLoaded = proposalID;
              this.loader.stopLoading();
              callback(pdf.Conteudo);
              }
            },
            (e) => {
              this.lastContractLoaded = null;
              this.toast.openAlert('Erro ao carregar contrato!', 'error');
              this.loader.stopLoading();
              callback(''); // ou null
            }
          );
      }
    });
  }

  getPDF(proposalID: string, cb?: () => any) {
    this.loader.startLoading();
    if (this.lastContractLoaded === proposalID) {
      this.loader.stopLoading();
      if (cb) return cb();
      return;
    }
    this.list.map((proposal: proposal) => {
      if (proposal.CodigoProposta == proposalID) {
        this.api
          .query(
            'proposta/documento/pdf',
            { requisicao: { token: this.token, Key: proposal.Key } },
            'post'
          )
          ?.subscribe(
            (pdf: any) => {
              this.pdf = pdf.Conteudo;
              this.lastContractLoaded = proposalID;
              this.loader.stopLoading();
            },
            (e) => {
              this.lastContractLoaded = null;
              this.toast.openAlert('Erro ao carregar contrato!', 'error');
              this.loader.stopLoading();
            },
            () => {
              if (cb) cb();
            }
          );
      }
    });
  }

  getContractPDF(proposalID: string, cb: (stream: any) => any) {
    this.loader.startLoading();
    this.list.map((proposal: proposal) => {
      if (proposal.CodigoProposta == proposalID) {
        this.api
          .query(
            'proposta/documento/assinado',
            { requisicao: { Token: this.token, Key: proposal.Key } },
            'post'
          )
          ?.subscribe(
            (pdf: any) => {
              this.pdf = pdf.Conteudo;
              this.loader.stopLoading();
              if (cb) cb(pdf.Conteudo);
            },
            (e) => {
              this.loader.stopLoading();
              this.toast.openAlert(
                'Erro ao carregar contrato assinado!',
                'error'
              );
            }
          );
      }
    });
  }

  // async download() {
  //   const source = 'data:application/pdf;base64,' + this.pdf;
  //   const link = document.createElement('a');
  //   link.href = source;
  //   link.download = `ContratoSabemiDigital.pdf`;
  //   link.click();
  // }

  async download(){
    const base64 = this.pdf;
    if (!base64) {
      console.error('PDF base64 não disponível');
      return;
    }
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
  
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
  
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'ContratoSabemiDigital.pdf';
    link.click();
  }

  async downloadPdf() {
    const isSafari =
      navigator.vendor &&
      navigator.vendor.indexOf('Apple') > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf('CriOS') == -1 &&
      navigator.userAgent.indexOf('FxiOS') == -1;

    if (isSafari) {
      const source = 'data:application/pdf;base64,' + this.pdf;
      await fetch(source)
        .then((res) => res.blob())
        .then((res) => {
          // console.log(URL.createObjectURL(res));
          this.linkContratoSafari =
            this.sanitizer.bypassSecurityTrustResourceUrl(
              window.URL.createObjectURL(res)
            );
        });
    } else {
      this.linkContratoSafari = null;
    }
  }

  onClickViewContract(proposal: any) {
    if (this.pdf === null) {
      this.toast.openAlert(
        'Houve um erro ao abrir o contrato tente novamente em alguns minutos!',
        'error'
      );
      this.location.back();
    }
    else {
      this.dialog.open(ModalContractDocumentComponent, {
        data: {
          icon: '',
          textIcon: 'contrato de assistência financeira',
          pdf: 'data:application/pdf;base64,' + this.pdf,
          descriptionImg: 'Contrato',
        },
      });
    }
  }

  onViewContractIframe() {
    return this.pdf
  }

  onClickViewContractByContent(content: any) {
    this.dialog.open(ModalContractDocumentComponent, {
      data: {
        icon: '',
        textIcon: 'contrato de assistência financeira',
        pdf: 'data:application/pdf;base64,' + content,
        descriptionImg: 'Contrato',
      },
    });
  }

  verifyPendencies() {
    // console.log(this.redirect);
    this.redirect = [];

    this.list.map((p: any) => {
      this.getHash(p);
      this.loader.startLoading();
      if (p.CodigoSituacao == 3) {
        const pKey = p.Key;
        const pHash = this.hash;
        this.api
          .query(
            'proposta/iniciar-atendimento',
            { requisicao: { Key: pKey, hash: pHash, token: this.token } },
            'post'
          )
          ?.subscribe((g: any) => {
            this.api
              .query(
                'proposta/pendencias',
                {
                  requisicao: {
                    Key: pKey,
                    hash: pHash,
                    token: this.token,
                  },
                },
                'post'
              )
              ?.subscribe((d: any) => {
                if (d.DocumentosPendentes.length > 0) {
                  this.redirect.push({
                    proposal: p,
                    route: 'documentos',
                    list: d.DocumentosPendentes,
                  });
                } else if (g.temPendeciaSelfies && p.CodigoFinanceira == 54) {
                  this.redirect.push({
                    proposal: p,
                    route: 'selfie/' + d.Selfies[1].type,
                  });
                } else if (d.PendenteAdr == true && !this.residencyDeclared) {
                  this.redirect.push({
                    proposal: p,
                    route: 'declaracao-endereco',
                  });
                } else if (
                  d.PendenteDebitoEmConta == true &&
                  !this.afterDebit
                ) {
                  this.redirect.push({
                    proposal: p,
                    route: 'debito-em-conta/autorizacao',
                  });
                } else if (!this.acceptedContract) {
                  this.redirect.push({
                    proposal: p,
                    route: 'contrato-documento',
                  });
                } else if (p.CodigoFinanceira == 54) {
                  this.redirect.push({ proposal: p, route: 'assinatura' });
                } else if (g.temPendeciaSelfies && p.CodigoFinanceira != 54) {
                  this.redirect.push({ proposal: p, route: 'contrato-documento' });
                }

                if (this.proposal) {
                  this.completeContract(this.proposal);
                  this.createTree(d, g);
                } else {
                  this.loader.stopLoading();
                }

                this.completeLoadContract.next(this.proposal);
              });
          });
      } else {
        this.loader.stopLoading();
      }
    });
  }

  getProposal(proposalCode: string) {
    this.list.map((l: any) => {
      if (l.CodigoProposta == proposalCode) {
        this.proposal = l;
      }
    });
  }

  completeContract(proposal: number) {
    // console.log({ proposal, redirect: this.redirect });
    this.pendentPayCheck = false;
    this.pendentExtract = false;
    this.pendentIndentityVerse = false;
    this.pendentInstallmentHistory = false;

    this.loader.stopLoading();
    this.redirect.map((x: any) => {
      // console.log(x);
      if (proposal == x.proposal.CodigoProposta) {
        this.getHash(x.proposal);

        this.activeProposal = {
          propostaKey: x.proposal.Key,
          hash: this.hash,
          proposalCode: x.proposal.CodigoProposta,
          financialCode: x.proposal.CodigoFinanceira,
        };

        if (!this.proposal) {
          this.route.navigate(['/formalizacao', x.proposalID, x.route]);
        }

        if (x.list) {
          x.list.map((l: any) => {
            if (l.CodigoTipoDocumento === 2) {
              this.pendentPayCheck = true;
              this.payCheckInfo = {
                hash: this.hash,
                Key: l.Key,
                PropostaKey: this.activeProposal.propostaKey,
                NomeDocumento: l.NomeDocumento,
                Conteudo: '',
                Origem: 'G',
                TipoDocumento: l.CodigoTipoDocumento,
              };
            } else if (l.CodigoTipoDocumento === 201) {
              this.pendentExtract = true;
              this.extractInfo = {
                hash: this.hash,
                Key: l.Key,
                PropostaKey: this.activeProposal.propostaKey,
                NomeDocumento: l.NomeDocumento,
                Conteudo: '',
                Origem: 'G',
                TipoDocumento: l.CodigoTipoDocumento,
              };
            } else if (l.CodigoTipoDocumento === 215) {
              this.pendentInstallmentHistory = true;
              this.extractInfo = {
                hash: this.hash,
                Key: l.Key,
                PropostaKey: this.activeProposal.propostaKey,
                NomeDocumento: l.NomeDocumento,
                Conteudo: '',
                Origem: 'G',
                TipoDocumento: l.CodigoTipoDocumento,
              };
            } else if (l.CodigoTipoDocumento === 3) {
              if (l.NomeDocumento == 'Identidade Frente') {
                this.pendentIndentity = true;
                this.IdentityInfo = {
                  hash: this.hash,
                  Key: l.Key,
                  PropostaKey: this.activeProposal.propostaKey,
                  NomeDocumento: l.NomeDocumento,
                  Conteudo: '',
                  Origem: 'G',
                  TipoDocumento: l.CodigoTipoDocumento,
                };
              } else if (l.NomeDocumento == 'Identidade Verso') {
                this.pendentIndentityVerse = true;
                this.IdentityInfoVerse = {
                  hash: this.hash,
                  Key: l.Key,
                  PropostaKey: this.activeProposal.propostaKey,
                  NomeDocumento: l.NomeDocumento,
                  Conteudo: '',
                  Origem: 'G',
                  TipoDocumento: l.CodigoTipoDocumento,
                };
              }
            }
          });
        }

        if (!this.hasDetails) {
          this.route.navigateByUrl('formalizacao/' + proposal + '/' + x.route);
        }
      }
    });
  }

  setActiveProposal(proposalID: string) {
    this.list.map((p: proposal) => {
      if (p.CodigoProposta == proposalID) {
        this.getHash(p);
        this.activeProposal = {
          propostaKey: p.Key,
          hash: this.hash,
          proposalCode: p.CodigoProposta,
          financialCode: p.CodigoFinanceira,
        };
        this.storage.set('activeProposalID', p.CodigoProposta);
      }
    });
  }

  getQrCode(type: string) {
    const hash = btoa(
      `${this.token}#${this.activeProposal.proposalCode}#${this.userData.CPF}${type ? '#' + type : ''
      }`
    );
    this.qrCodeLink = environment.qrCodeLinkPrefix + `/${hash}`;
  }

  openProposal(proposal: any, load: any) {
    this.proposal = proposal;
    if (proposal.CodigoSituacao == 2) {
      this.route.navigate([
        '/contratos/',
        proposal.CodigoProposta,
        'solicitacao-encaminhada-padrao',
      ]);
    } else if (proposal.CodigoSituacao == 3) {
      this.route.navigate([
        '/contratos/',
        proposal.CodigoProposta,
        'solicitacao-com-pendencia',
      ]);
    } else if (proposal.CodigoSituacao == 0) {
      this.route.navigate([
        '/contratos',
        proposal.CodigoProposta,
        'solicitacao-aprovada',
      ]);
    }
  }

  async getHash(proposal: any) {
    this.hash = window.btoa(
      `${proposal.CodigoProposta}#${proposal.Key}#${proposal.Tipo}`
    );
  }

  getContract(proposal: any) {
    this.getHash(proposal);
  }

  getBankInformation() {
    this.loader.startLoading();

    this.api
      .query(
        `debito-em-conta/dados-proposta/${this.activeProposal.proposalCode}` +
        '?token=' +
        this.token +
        '',
        {},
        'get'
      )
      ?.subscribe((data: any) => {
        if (data.Sucesso) {
          this.userBankInfo = data.Retorno;
          this.getUrlBank();
        }
      });
  }

  async getUrlBank() {
    this.loader.stopLoading();
    const params = {
      'requisicao.cpf': this.userData.CPF,
      'requisicao.codProposta': this.activeProposal.proposalCode,
      'requisicao.numAgencia': this.userBankInfo.agencyCode,
      'requisicao.numConta': this.userBankInfo.accountNumber,
    };

    this.api
      .query(
        `debito-em-conta/link-acesso` + '?token=' + this.token + '',
        { params },
        'get'
      )
      ?.subscribe((data: any) => {
        if (data.Sucesso) {
          this.debitUrl = data.Retorno.urlDirecionamento;
          this.loader.stopLoading();
        }
      });
  }

  createTree(t: any, p: any) {
    // console.log(this.steps);
    this.steps = [];

    if (t.DocumentosPendentes.length > 0) {
      this.steps.push('documentos');
      this.documentsPendents.documentos = true;
      this.documentsPendents.qty = t.DocumentosPendentes.length;
    }
    if (p.temPendeciaSelfies && this.activeProposal.financialCode == 54) {
      this.steps.push('contrato-documento');
      this.documentsPendents.contrato = true;
      //this.steps.push('selfie');      
    }
    if (t.PendenteAdr && !this.residencyDeclared) {
      this.steps.push('declaracao-endereco');
      this.documentsPendents.dados = true;
    }
    if (t.PendenteDebitoEmConta && !this.afterDebit) {
      this.steps.push('debito-em-conta/autorizacao');
      this.documentsPendents.dados = true;
    }
    if (!this.acceptedContract) {
      this.steps.push('contrato-documento');
      this.documentsPendents.contrato = true;
    }
    if (p.temPendeciaSelfies && this.activeProposal.financialCode != 54) {
      this.steps.push('contrato-documento');
      this.documentsPendents.contrato = true;
      //this.steps.push('selfie');
    }
    if (this.activeProposal.financialCode == 54) {
      this.steps.push('assinatura');
    }
    if (t.PendenteDebitoEmConta && this.afterDebit) {
      this.steps.push('debito-em-conta/autorizacao');
      this.documentsPendents.dados = true;
    }
  }

  confirmSelfie() {
    this.loader.startLoading();
    const activeProposalIDTemp = this.storage.get('activeProposalID');
    this.api
      .query(
        'proposta',
        { requisicao: { CPF: this.userData.CPF, Token: this.token } },
        'post'
      )
      ?.subscribe((data: any) => {
        data.PropostasPendentesDocumento.map(async (proposal: proposal) => {
          if (!this.hash) {
            await this.getHash(proposal);
          }
          // console.log(this.activeProposal);
          // if(this.activeProposal.length <= 0){
          //   this.activeProposal = {propostaKey: proposal.Key, hash: this.hash, proposalCode: proposal.CodigoProposta, financialCode: proposal.CodigoFinanceira}
          // }else{
          //   this.storage.get('activeProposalID')
          // }

          if (proposal.CodigoProposta == activeProposalIDTemp) {
            this.activeProposal = {
              propostaKey: proposal.Key,
              hash: this.hash,
              proposalCode: proposal.CodigoProposta,
              financialCode: proposal.CodigoFinanceira,
            };
            // console.log(this.activeProposal);
            if (proposal.CodigoSituacao == 2) {
              this.getProposalDetails(
                data.PropostasPendentesDocumento,
                this.activeProposal.proposalCode
              );
              this.completeLoadContracts.next(data);
              this.hasContracts = true;

              this.finalizarAtendimento();
            } else if (proposal.CodigoFinanceira == 54) {
              this.loader.stopLoading();
              this.route.navigateByUrl(
                `formalizacao/${this.activeProposal.proposalCode}/assinatura`
              );
            } else {
              this.toast.openAlert(
                'Você precisa enviar a selfie para continuar',
                'error'
              );
              this.loader.stopLoading();
            }
          }
        });
      });

    // this.api.query('proposta/iniciar-atendimento', {requisicao: {Key: this.activeProposal.propostaKey, hash: this.activeProposal.hash, token: this.token}}, 'post')?.subscribe((d:any) => {

    //   if(!d.temPendeciaSelfies){

    //     if(this.steps==1){
    //       this.finalizarAtendimento()
    //     }
    //     else
    //     {
    //       this.route.navigateByUrl('formalizacao/'+this.activeProposal.proposalCode+'/'+this.steps[1])
    //       this.steps.splice(0, 1)
    //     }

    //   }
    //   else
    //   {
    //     this.toast.openAlert('Você precisa enviar a selfie para continuar', 'error')
    //     this.loader.stopLoading()
    //   }

    // })
  }

  finalizarAtendimento() {
    this.loader.startLoading();
    this.api
      .query(
        'proposta/finalizar-atendimento',
        {
          requisicao: {
            Key: this.activeProposal.propostaKey,
            hash: this.activeProposal.hash,
            token: this.token,
          },
        },
        'post'
      )
      ?.subscribe((data: any) => {
        if (data.Sucesso) {
          //this.api.query('proposta', {requisicao: {CPF: this.userData.CPF, Token: this.token}}, 'post')?.subscribe((data: any) => {
          // console.log('finalizarAtendimento');
          this.loader.stopLoading();
          this.route.navigateByUrl(
            `contratos/${this.activeProposal.proposalCode}/solicitacao-encaminhada-padrao`
          );
          //})
        }
      });
  }

  finalizarAtendimentoNovo() {
    this.api
      .query(
        'proposta/finalizar-atendimento',
        {
          requisicao: {
            Key: this.activeProposal.propostaKey,
            hash: this.activeProposal.hash,
            token: this.token,
          },
        },
        'post'
      )?.subscribe({ error: () => {} });
  }

  async atualizarPropostas() {
    this.loader.startLoading();
    await this.getProposta(false);
  }
}
